export default __webpack_public_path__ + "static/media/helm.da186395.svg";